(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
    $('.similar-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          infinite: false          
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          infinite: false
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: false          
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
    $('.review-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
    const starRatings = document.querySelectorAll('.star-rating');
    starRatings.forEach(starRatingElement => {
          const ratingValue = parseFloat(starRatingElement.getAttribute('data-rating'));
          const maxRating = 5;
          let starHtml = '';
    
          for (let i = 1; i <= maxRating; i++) {
              if (i <= Math.floor(ratingValue)) {
                  starHtml += '<span class="filled">&#9733;</span>'; // Filled star
              } else if (i - 0.5 === Math.floor(ratingValue) + 0.5) {
                  starHtml += '<span class="half">&#9733;</span>'; // Half star
              } else {
                  starHtml += '<span>&#9734;</span>'; // Empty star
              }
          }
      starRatingElement.innerHTML = starHtml;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-featured"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {
            const tabButtons = document.querySelectorAll(".tab-btn");
            const tabContents = document.querySelectorAll(".tab-box > div");

            tabButtons.forEach(button => {
                button.addEventListener("click", () => {
                    // Remove active class from all buttons
                    tabButtons.forEach(btn => btn.classList.remove("active"));
                    // Add active class to the clicked button
                    button.classList.add("active");

                    // Remove active class from all tab contents
                    tabContents.forEach(content => content.classList.remove("active"));
                    // Add active class to the corresponding tab content
                    const tabId = button.getAttribute("data-tab");
                    document.querySelector(`.${tabId}`).classList.add("active");
                });
            });
        });

  } catch(e) { console.error(e); }
})();
})();
